export const environment = {
    production: true,
    name: 'Staging',
    apiUrl: 'https://residenz-sta.chapps.com/',
    managerUrl: 'https://manager-residenz-sta.chapps.com'
  };